(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vg-collection-schema"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.vgCollectionSchemaGuard) return;
    window.vgCollectionSchemaGuard = true;
    const types = (node, result = new Set()) => {
      if (Array.isArray(node)) node.forEach(item => types(item, result));
      else if (node && typeof node === 'object') {
        [].concat(node['@type'] || []).forEach(type => result.add(String(type).replace(/^https?:\/\/schema\.org\//, '')));
        Object.values(node).forEach(value => {
          if (value && typeof value === 'object') types(value, result);
        });
      }
      return result;
    };
    const completeLists = new Map();
    const pending = new WeakSet();
    const complete = script => {
      if (!script.dataset.vgProductsUrl || pending.has(script) || typeof fetch !== 'function') return;
      let list;
      try { list = JSON.parse(script.textContent); } catch (_) { return; }
      const knownOffers = new Map((list.itemListElement || []).filter(entry => entry.item?.offers).map(entry => [new URL(entry.url, location.href).pathname, entry.item.offers]));
      const total = Number(list.numberOfItems);
      if (!Number.isSafeInteger(total) || total <= 0 || list.itemListElement.length >= total) return;
      const endpoint = new URL(script.dataset.vgProductsUrl, location.href);
      if (endpoint.origin !== location.origin) return;
      const key = endpoint.href + ':' + total;
      pending.add(script);
      if (!completeLists.has(key)) completeLists.set(key, (async () => {
        const products = new Map();
        for (let page = 1; page <= Math.ceil(total / 250); page++) {
          const url = new URL(endpoint);
          url.searchParams.set('limit', '250');
          url.searchParams.set('page', String(page));
          const response = await fetch(url.href, {credentials: 'same-origin'});
          if (!response.ok) throw new Error('Collection membership unavailable');
          const payload = await response.json();
          if (!Array.isArray(payload.products)) throw new Error('Invalid collection membership');
          payload.products.forEach(product => {
            if (!product.id || typeof product.handle !== 'string' || !product.handle || typeof product.title !== 'string') throw new Error('Invalid product');
            products.set(String(product.id), product);
          });
        }
        if (products.size !== total) throw new Error('Collection membership changed; retain server schema');
        const productBase = endpoint.pathname.split('/collections/')[0] + '/products/';
        return Array.from(products.values(), (product, index) => ({
          '@type': 'ListItem', name: product.title, position: index + 1,
          url: new URL(productBase + encodeURIComponent(product.handle), endpoint.origin).href,
          item: {
            '@type': 'Product', name: product.title,
            brand: {'@type': 'Brand', name: product.vendor},
            url: new URL(productBase + encodeURIComponent(product.handle), endpoint.origin).href,
            ...(product.images?.[0]?.src ? {image: product.images[0].src.replace(/^http:/, 'https:')} : {}),
            ...(knownOffers.has(productBase + encodeURIComponent(product.handle)) ? {offers: knownOffers.get(productBase + encodeURIComponent(product.handle))} : {})
          }
        }));
      })());
      completeLists.get(key).then(items => {
        if (!script.isConnected) return;
        const current = JSON.parse(script.textContent);
        if (current['@id'] !== list['@id'] || current.numberOfItems !== total) return;
        current.itemListElement = items;
        script.textContent = JSON.stringify(current).replace(/</g, '\\u003c');
      }).catch(() => {});
    };
    let scheduled = false;
    const reconcile = () => {
      scheduled = false;
      const external = new Set();
      document.querySelectorAll('script[type="application/ld+json"]:not([data-vg-collection-schema])').forEach(script => {
        try { types(JSON.parse(script.textContent)).forEach(type => external.add(type)); } catch (_) {}
      });
      const lists = Array.from(document.querySelectorAll('script[data-vg-collection-schema="ItemList"]'));
      if (!external.has('ItemList') && lists.length > 1) {
        try {
          const merged = JSON.parse(lists[0].textContent);
          const seen = new Set();
          merged.itemListElement = lists.flatMap(script => JSON.parse(script.textContent).itemListElement || [])
            .filter(item => { if (seen.has(item.url)) return false; seen.add(item.url); return true; });
          merged.numberOfItems = Math.max(merged.itemListElement.length, ...lists.map(script => Number(JSON.parse(script.textContent).numberOfItems) || 0));
          lists[0].textContent = JSON.stringify(merged).replace(/</g, '\\u003c');
        } catch (_) {}
      }
      const kept = new Set();
      document.querySelectorAll('script[data-vg-collection-schema]').forEach(script => {
        const type = script.dataset.vgCollectionSchema;
        if (external.has(type) || kept.has(type)) script.remove();
        else kept.add(type);
      });
      document.querySelectorAll('script[data-vg-collection-schema="ItemList"]').forEach(complete);
      if (!kept.has('ItemList')) {
        document.querySelectorAll('script[data-vg-collection-schema="CollectionPage"]').forEach(script => script.remove());
      }
    };
    const schedule = () => { if (!scheduled) { scheduled = true; queueMicrotask(reconcile); } };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
    else schedule();
    new MutationObserver(records => {
      if (records.some(record => record.target.nodeName === 'SCRIPT' || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('script') || node.querySelector('script'))))) schedule();
    }).observe(document.documentElement, {childList:true, subtree:true, characterData:true});
  })();
  } catch(e) { console.error(e); }
})();

})();
